import { VerticalFormItem } from '@components/display';
import { useAppTranslation } from '@hooks/useAppTranslation';
import { useEffect, useState } from 'react';
import { CardFormSelected } from '@views/shared/form';
import { getForm } from '@api/form';
import { FormType } from '@pages/types';
import { Title, TextInput, Text, colors, FormElements, Space } from 'common-components';

import { formApiMapper } from '@/mappers';

type GeneralSettingsPanelPropsType = {
  name: string
  idForm: string
  modifEnabled?: boolean
};

export const GeneralSettingsPanel = ({
  name,
  idForm,
  modifEnabled,
}: GeneralSettingsPanelPropsType) => {
  const [templateFrom, setTemplateFrom] = useState<FormType['template']['template']>();
  const { translate } = useAppTranslation();
  const form = FormElements.useFormInstance();

  useEffect(() => {
    getForm(idForm).then((formApi) => {
      const result = formApiMapper(formApi)?.template?.template;
      setTemplateFrom(result);
    });
  }, [idForm]);

  useEffect(() => {
    if (form && name) form.setFieldValue('name', name);
  }, [form, name]);

  return (
    <Space
      orientation="vertical"
      size={22}
      style={{
        width: '100%',
        border: `1px solid ${colors.gray200}`,
        borderRadius: 12,
        padding: 24,
      }}
    >
      <Title level={5} style={{ color: colors.gray900 }}>
        {translate('projectCreatePage.collapse.generalSettings.title')}
      </Title>
      <VerticalFormItem
        label={translate('project.settings.labels.name')}
        name="name"
        rules={[{ required: true, message: translate('common.validation.required') }]}
      >
        <TextInput disabled={!modifEnabled} />
      </VerticalFormItem>
      {!!templateFrom && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Text size="sm" color={colors.gray700} style={{ fontWeight: 500 }}>
            {translate('project.settings.labels.form')}
          </Text>
          <CardFormSelected templateFrom={templateFrom} />
        </div>
      )}
    </Space>
  );
};

export default GeneralSettingsPanel;
